import {createContext, useState} from "react";

export const UserContext = createContext({
    user: null,
    role: null,
    login: () => {},
    updateUser: () => {},
    logout: () => {}
});

const USER_KEY = "user";
const TOKEN_KEY = "token";

const readUser = () => {
    try {
        return JSON.parse(localStorage.getItem(USER_KEY));
    } catch (error) {
        return null;
    }
}

const decodeRole = (token) => {
    try {
        const payload = token.split('.')[1];
        return JSON.parse(atob(payload)).role || "user";
    } catch (error) {
        return null;
    }
}

const mapUser = (data) => ({
    id: data.id,
    name: data.name,
    surname: data.surname && data.surname !== 'null' ? data.surname : '',
    email: data.email,
    image: typeof data.image === "string" ? data.image : data.image?.url ?? null,
    color: data.color
});

const UserProvider = ({children}) => {
    const [user, setUser] = useState(readUser);
    const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));

    const saveUser = (newUser) => {
        localStorage.setItem(USER_KEY, JSON.stringify(newUser));
        setUser(newUser);
    }

    const login = (data) => {
        localStorage.setItem(TOKEN_KEY, data.token);
        setToken(data.token);
        saveUser(mapUser(data));
    }

    const updateUser = (data) => saveUser({...user, ...mapUser({...user, ...data})});

    const logout = () => {
        localStorage.clear();
        setToken(null);
        setUser(null);
    }

    const value = {
        user,
        role: decodeRole(token),
        login,
        updateUser,
        logout
    };

    return (
        <UserContext.Provider value={value}>
            {children}
        </UserContext.Provider>
    );
}

export default UserProvider
